import { DateUtil, isNullOrUndefined } from '@uzurv/rideWss/app/util';
import { AbstractModel } from './abstract-model';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { CancellationReason } from './cancellation-reason';
import { Driver } from './driver';
import { RideRequest } from './ride-request';

@inheritSerialization(AbstractModel)
export class Reservation extends AbstractModel {
  @autoserializeAs(Date)
  pickUpArrivedDate: Date;

  @autoserializeAs(Date)
  driverEnRouteDate: Date;

  @autoserializeAs(Date)
  inProgressDate: Date;

  @autoserializeAs(Date)
  dropOffArrivedDate: Date;

  @autoserializeAs(Driver)
  driver: Driver;

  @autoserializeAs(RideRequest)
  rideRequest: RideRequest;

  @autoserializeAs(Date)
  completedDate: Date;

  @autoserialize
  cancelled: boolean;

  @autoserializeAs(CancellationReason)
  cancellationReason: CancellationReason;

  @autoserializeAs(Date)
  cancelledDate: Date;

  @autoserialize
  driverCharged: boolean;

  @autoserialize
  referralPaid: boolean;

  @autoserialize
  riderConfirmedPickup: boolean;

  @autoserialize
  vehicleId: number;

  @autoserialize
  createdByUserId: number;

  @autoserialize
  cancelledByUserId: number;

  // TODO: Remove this if it doesn't cause any issue
  // @autoserializeAs(ChatMessage)
  // chatMessages: Array<ChatMessage>;

  @autoserialize
  reservationStatusId: number;

  @autoserialize
  riderChargeId: number;

  @autoserialize
  providerId: number;

  @autoserialize
  journeyId: number;

  static OnSerialized(reservation: Reservation, json: any): void {
    super.OnSerialized(reservation, json);

    if (!isNullOrUndefined(reservation.cancelledDate)) {
      json.cancelledDate = DateUtil.serializeDate(reservation.cancelledDate);
    }
    if (!isNullOrUndefined(reservation.completedDate)) {
      json.completedDate = DateUtil.serializeDate(reservation.completedDate);
    }
    if (!isNullOrUndefined(reservation.pickUpArrivedDate)) {
      json.pickUpArrivedDate = DateUtil.serializeDate(reservation.pickUpArrivedDate);
    }
    if (!isNullOrUndefined(reservation.driverEnRouteDate)) {
      json.driverEnRouteDate = DateUtil.serializeDate(reservation.driverEnRouteDate);
    }
    if (!isNullOrUndefined(reservation.dropOffArrivedDate)) {
      json.dropOffArrivedDate = DateUtil.serializeDate(reservation.dropOffArrivedDate);
    }
    if (!isNullOrUndefined(reservation.inProgressDate)) {
      json.inProgressDate = DateUtil.serializeDate(reservation.inProgressDate);
    }
  }

  static OnDeserialized(instance: Reservation, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['cancelledDate'])) {
      instance.cancelledDate = DateUtil.deserializeDate(json['cancelledDate']);
    }

    if (!isNullOrUndefined(json['completedDate'])) {
      instance.completedDate = DateUtil.deserializeDate(json['completedDate']);
    }

    if (!isNullOrUndefined(json['pickUpArrivedDate'])) {
      instance.pickUpArrivedDate = DateUtil.deserializeDate(json['pickUpArrivedDate']);
    }

    if (!isNullOrUndefined(json['driverEnRouteDate'])) {
      instance.driverEnRouteDate = DateUtil.deserializeDate(json['driverEnRouteDate']);
    }

    if (!isNullOrUndefined(json['dropOffArrivedDate'])) {
      instance.dropOffArrivedDate = DateUtil.deserializeDate(json['dropOffArrivedDate']);
    }

    if (!isNullOrUndefined(json['inProgressDate'])) {
      instance.inProgressDate = DateUtil.deserializeDate(json['inProgressDate']);
    }
  }
}
